/* ============================================================
   Notre Chanson — pixel.js
   Meta (Facebook) Pixel — base loader + PageView, shared across
   every page so the ID lives in ONE place.

   Pixel ID: 1046571661302988

   Funnel events (fired from page code, never here):
     • ViewContent      — composer.html (product configurator)
     • AddToCart        — panier.html (cart reached)
     • Lead             — recap.html (email captured)

   Handled by SHOPIFY, deliberately NOT tracked here (le tracker des
   deux côtés compterait en double) :
     • InitiateCheckout — déclenché au chargement du checkout Shopify
     • Purchase         — l'acheteur a quitté le site statique

   Use window.nmPixel(event, params) for guarded tracking so a
   blocked/ًabsent pixel never throws.

   ⚠️ RGPD : ce pixel se déclenche au chargement, sans bandeau de
   consentement (choix actuel). Pour être pleinement conforme, il
   faudra ne l'initialiser qu'après acceptation des cookies.
   ============================================================ */
(function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
  if (!f._fbq) f._fbq = n;
  n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
  t = b.createElement(e); t.async = !0; t.src = v;
  s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));

fbq('init', '1046571661302988');
fbq('track', 'PageView');

/* Guarded helper: window.nmPixel('InitiateCheckout', {value:39,currency:'EUR'}) */
window.nmPixel = function (event, params) {
  if (window.fbq) { try { fbq('track', event, params || {}); } catch (e) { /* no-op */ } }
};
